import { Link } from 'react-router-dom';
import { categories } from '@/mocks/content';

export default function CategoryNav() {
  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            中文字幕日韩影视全品类导航
          </h2>
          <p className="text-foreground-600 text-sm max-w-[550px] mx-auto">
            日剧、韩剧、电影、综艺 — 四大品类全面覆盖，助你轻松找到想看的内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative bg-background-100 rounded-xl p-6 md:p-7 hover:bg-background-200/70 transition-all duration-300 cursor-pointer overflow-hidden"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-5 group-hover:scale-110 transition-transform duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {cat.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">{cat.count}+ 部作品</span>
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-500 text-background-50 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-arrow-right-line text-xs"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}